/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorLikes.defs.js'
export * as $defs from './getActorLikes.defs.js'
